export default __webpack_public_path__ + "static/media/fullform.645858f6.png";